import { render, staticRenderFns } from "./MySalesSidebar.vue?vue&type=template&id=4ce92f45&"
import script from "./MySalesSidebar.vue?vue&type=script&lang=js&"
export * from "./MySalesSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports